import { ChangeDetectionStrategy, Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { IndPageTitleComponent } from '../ind-page-title/ind-page-title';
import { DeviceService } from '../../../services/device/device.service';
import { EventsService } from '../../../services/events/events.service';
import { TranslateService } from '@ngx-translate/core';

import { UIService } from '../../../services/ui/ui.service';

@Component({
    selector: 'nothing-selected-view',
    templateUrl: 'nothing-selected-view.html',
    styleUrls:['nothing-selected-view.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, IonicModule, IndPageTitleComponent],
  })
  export class NothingSelectedView implements OnInit {

    @Input() textToDisplay: string;
    @Input() notShowText = false;
    @Input() deviceString: string;
    platform: string;
    constructor(
                private readonly translate: TranslateService, 
                private readonly uiService: UIService,
                private readonly events: EventsService,
                public readonly deviceService: DeviceService,
                private readonly cdr: ChangeDetectorRef) {
    }
    ngOnInit(){
      // Only set textToDisplay if it's not already provided via @Input
      if (!this.textToDisplay) {
        this.textToDisplay = this.translate.instant('NOTHING_SELECTED');
      }
      this.events.subscribe('nothingSelectedMessageUpdate', ()=>{
        const newMessage = this.uiService.nothingSelectedScreenMessage;
        // Only update if the new message is not empty
        if (newMessage && newMessage.trim() !== '') {
          this.textToDisplay = newMessage;
          this.cdr.markForCheck();
        }
      });
      this.events.subscribe('other', () => {
        this.platform = 'other';
        this.cdr.markForCheck();
      });
    }
  }

